import { Route } from 'react-router-dom'
import Layout from './../components/layout/Layout'
import Login from './../pages/Login'
import Inicio from './../pages/Inicio'
import Logout from './../pages/Logout'
import NotFound from './../pages/NotFound'
import Users from './../pages/Users'
import Clientes from './../pages/Clientes'
import Cotizaciones from './../pages/cotizaciones/Cotizaciones'
import RegistrarCotizacion from './../pages/cotizaciones/registro/RegistrarCotizacion'
import EditarCotizacion from './../pages/cotizaciones/edicion/EditarCotizacion'
import Contratos from './../pages/contratos/Contratos'
import Proveedores from './../pages/proveedores/Proveedores'
import Profesionales from './../pages/profesionales/Profesionales'
import ProtectedRoute from './../components/ProtectedRoute'
import MaestrosRoutes from './maestrosRoutes' 
import UserRoutes from './userRoutes' 
import PaquetesRoutes from './paquetesRoutes' 
import ReportesRoutes from './reportesRoutes' 

const MainRoutes = () => (
  <>
    {/* Ruta inicial */}
    <Route path="/" element={<Login />} />

    {/* Ruta con Layout común */}
    <Route element={<Layout />}>
      {/* Rutas protegidas */}
      <Route path="/inicio" element={<Inicio />} />

      <Route
        path="/users"
        element={
          <ProtectedRoute requiredModule="usuarios">
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clientes"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Clientes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cotizaciones"
        element={
          <ProtectedRoute requiredModule="cotizaciones">
            <Cotizaciones />
          </ProtectedRoute>
        }
      />
      <Route
        path="/registrar_cotizacion"
        element={
          <ProtectedRoute requiredModule="cotizaciones">
            <RegistrarCotizacion />
          </ProtectedRoute>
        }
      />

      <Route
        path="/editar_cotizacion"
        element={
          <ProtectedRoute requiredModule="cotizaciones">
            <EditarCotizacion />
          </ProtectedRoute>
        }
      />

      <Route
        path="/contratos"
        element={
          <ProtectedRoute requiredModule="contratos">
            <Contratos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/proveedores"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Proveedores/>
          </ProtectedRoute>
        }
      />
       <Route
        path="/profesionales"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Profesionales/>
          </ProtectedRoute>
        }
      />
      {MaestrosRoutes()} 
      {PaquetesRoutes()} 
      {ReportesRoutes()} 
      {UserRoutes()} 
    </Route>

    {/* Ruta de Logout */}
    <Route path="/logout" element={<Logout />} />

    {/* Ruta de Not Found */}
    <Route path="*" element={<NotFound />} />
  </>
)

export default MainRoutes
